import D2C_ServiceApp from './App'

class D2C_ServiceRuby extends D2C_ServiceApp {
  static objectType = 'serviceType'
  static active = true
  static order = 16
  static typeName = 'ruby'
  static typeTitle = 'Ruby'
  static color = '#cc0000'
  static methods = {
    ...D2C_ServiceApp.methods,
    scale: true,
  }
  static fields = {
    ...D2C_ServiceApp.fields,
    buildCommands: {
      ...D2C_ServiceApp.fields.buildCommands,
      default: 'bundle install --jobs 8',
    },
    hosts: {
      ...D2C_ServiceApp.fields.hosts,
      selector: {
        default: ['node', 'node'],
      },
    },
    image: {
      ...D2C_ServiceApp.fields.image,
      default: 'ruby',
    },
    ports: {
      ...D2C_ServiceApp.fields.ports,
      default: [
        {protocol: 'TCP', value: 3000},
      ],
    },
    source: {
      ...D2C_ServiceApp.fields.source,
      example: 'https://github.com/d2cio/ruby-hello-world',
    },
    startCommand: {
      default: 'bundle exec ruby server.rb',
      label: 'Command to start',
      path: 'startCommand',
      required: false,
      syntaxis: 'shell',
      validate() {
        return null
      },
      creating: {},
      importing: {},
      updating: {},
    },
    version: {
      ...D2C_ServiceApp.fields.version,
      default: '3.0',
      enum: ['2.1', '2.2', '2.3', '2.4', '2.5', '2.6', '2.7', '3.0'],
    },
    volumes: {
      ...D2C_ServiceApp.fields.volumes,
      demo: [
        {src: '/ebs/containers/$serviceName/sources', dst: '/var/www/$serviceName', sync: false},
      ],
    },
  }
}

export default D2C_ServiceRuby
